import React from 'react';
import { ui } from '../ui';

/** Segmented tabs used by the analyst screens; `chip` style, keyboard-navigable via native buttons. */
export function Tabs<K extends string>({ value, onChange, items, label }: { value: K; onChange: (k: K) => void; items: { key: K; label: React.ReactNode }[]; label?: string }) {
  return (
    <div role="tablist" aria-label={label} style={ui.row(6)}>
      {items.map(it => <button key={it.key} type="button" role="tab" aria-selected={value === it.key} style={ui.chip(value === it.key)} onClick={() => onChange(it.key)}>{it.label}</button>)}
    </div>
  );
}
